<template>
  <div class="project-details-page" :dir="lang === 'Ar' ? 'rtl' : 'ltr'">
    <Loading v-show="show" />

    <div v-if="project" class="content-wrapper">
      <!-- Header Section -->
      <div class="page-header">
        <div class="header-overlay"></div>
        <div class="header-content">
          <router-link to="/StudentsProjects" class="back-link">
            <i class="fa" :class="lang === 'Ar' ? 'fa-arrow-right' : 'fa-arrow-left'"></i>
            {{ translate.Projects.BackToProjects }}
          </router-link>
          
          <div class="badges">
            <span class="badge">{{ getValue('txtYear') }}</span>
            <span class="badge major">{{ getValue('txtUniversityMajor') }}</span>
          </div>
          
          <h1>{{ project.postTitle }}</h1>
          <p class="subtitle">{{ project.postSubTitle }}</p>
          
          <div class="meta-info">
            <div class="meta-item">
              <i class="fa fa-user"></i>
              <div>
                <span class="label">{{ translate.Projects.Student }}</span>
                <span class="value">{{ getValue('txtstudentName') }}</span>
              </div>
            </div>
            
            <div class="meta-item">
              <i class="fa fa-user-tie"></i>
              <div>
                <span class="label">{{ translate.Projects.Supervisor }}</span>
                <span class="value">{{ getValue('txtsupervisorName') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Section -->
      <div class="main-container">
        <div class="grid-layout">
          
          <!-- Image and File Sidebar -->
          <div class="sidebar">
            <div class="image-card">
              <img :src="getImageUrl(project.postImage)" :alt="project.postTitle" @error="handleImageError" />
            </div>
            
            <a v-if="project.postFile" :href="getFileUrl(project.postFile)" target="_blank" class="download-btn">
              <i class="fa fa-download"></i>
              {{ translate.Projects.DownloadFile }}
            </a>
          </div>

          <!-- HTML Details Content -->
          <div class="content-card">
            <h2 class="section-title">{{ translate.Projects.DetailsTitle }}</h2>
            <div class="html-content" v-html="project.postDetails"></div>
          </div>

        </div>
      </div>
    </div>

    <!-- Empty State / Error -->
    <div v-else-if="!show" class="error-state">
      <i class="fa fa-exclamation-circle"></i>
      <h3>{{ translate.Projects.NotFound }}</h3>
      <p>{{ translate.Projects.NotFoundDesc }}</p>
      <router-link to="/StudentsProjects" class="back-btn">{{ translate.Projects.BackToProjects }}</router-link>
    </div>
  </div>
</template>

<script>
import Loading from './Loading.vue';
import axios from 'axios';
import ArJson from "../../public/i18n/Ar.json";
import EnJson from "../../public/i18n/En.json";

export default {
  name: 'StudentProjectDetails',
  components: {
    Loading
  },
  data() {
    return {
      project: null,
      show: true,
      lang: "Ar",
      translate: ArJson[0],
      defaultImage: "https://via.placeholder.com/800x600?text=لا+توجد+صورة"
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.lang = localStorage.getItem("lang") || "Ar";
    this.translate = this.lang === "Ar" ? ArJson[0] : EnJson[0];

    if (this.lang !== "Ar") {
      let link1 = document.createElement("link");
      link1.setAttribute("rel", "stylesheet");
      link1.id = "langfilewebsites";
      link1.setAttribute("href", "../../../style-ltr.css");
      if (!document.getElementById("langfilewebsites")) {
        document.head.appendChild(link1);
      }
    } else {
      document.getElementById("langfilewebsites")?.remove();
    }

    this.fetchProjectDetails();
  },
  methods: {
    fetchProjectDetails() {
      this.show = true;
      const projectId = this.$route.params.id;
      
      const bodyFormData = new FormData();
      bodyFormData.append("check", "getPostById");
      bodyFormData.append("PostId", projectId);
      bodyFormData.append("Lang", this.lang);
      bodyFormData.append("Type", "Univ.StudentsProjects");
      bodyFormData.append("ParentId", "NTROOT0");
      bodyFormData.append("Pno", "-1");

      axios({
        method: "post",
        url: "https://api2.yg-u.net:444/our_team/getPost",
        data: bodyFormData,
      })
      .then((response) => {
        if(Array.isArray(response.data) && response.data.length > 0) {
          this.project = response.data[0];
        }
        this.show = false;
      })
      .catch((error) => {
        console.error("Error fetching project details:", error);
        this.show = false;
      });
    },
    getValue(key) {
      if (!this.project) return 'غير محدد';
      if (this.project[key]) return this.project[key];
      if (this.project[key + '1']) return this.project[key + '1'];
      return 'غير محدد';
    },
    getImageUrl(imageName) {
      if (!imageName) return this.defaultImage;
      return `https://api2.yg-u.net:444/images/post/${imageName}`;
    },
    getFileUrl(fileName) {
      if (!fileName) return '#';
      // Adjust file path URL base according to API structure
      return `https://api2.yg-u.net:444/images/post/${fileName}`; 
    },
    handleImageError(e) {
      e.target.src = this.defaultImage;
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800&display=swap');

.project-details-page {
  font-family: 'Tajawal', sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
  padding-bottom: 60px;
}

/* Header */
.page-header {
  background: linear-gradient(135deg, #21467d 0%, #3498db 100%);
  padding: 50px 20px 80px;
  color: white;
  position: relative;
}

.header-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: url('https://www.transparenttextures.com/patterns/cubes.png');
  opacity: 0.05;
}

.header-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-weight: 500;
  margin-bottom: 30px;
  transition: color 0.3s ease;
}

.back-link:hover {
  color: white;
}

.badges {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.badge {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
  padding: 6px 15px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 700;
}

.badge.major {
  background: #3b82f6;
}

.header-content h1 {
  font-size: 38px;
  font-weight: 800;
  margin: 0 0 15px 0;
  line-height: 1.4;
}

.subtitle {
  font-size: 18px;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 0 30px 0;
  line-height: 1.6;
}

.meta-info {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 25px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.meta-item i {
  font-size: 24px;
  color: #60a5fa;
  background: rgba(96, 165, 250, 0.1);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.meta-item .label {
  display: block;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 4px;
}

.meta-item .value {
  display: block;
  font-size: 16px;
  font-weight: 700;
}

/* Main Content */
.main-container {
  max-width: 1200px;
  margin: -40px auto 0;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}

.grid-layout {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: 30px;
  align-items: start;
}

.image-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0,0,0,0.05);
  margin-bottom: 20px;
}

.image-card img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px;
  background: #10b981;
  color: white;
  text-decoration: none;
  border-radius: 12px;
  font-weight: 700;
  font-size: 16px;
  transition: background 0.3s ease;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.2);
}

.download-btn:hover {
  background: #059669;
}

.content-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.05);
}

.section-title {
  font-size: 24px;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f1f5f9;
}

/* HTML Content Styling */
.html-content {
  color: #334155;
  line-height: 1.8;
  font-size: 16px;
}

.html-content :deep(h1), .html-content :deep(h2), .html-content :deep(h3) {
  color: #0f172a;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  font-weight: 700;
}

.html-content :deep(ul), .html-content :deep(ol) {
  padding-right: 20px;
  margin-bottom: 1em;
}

.html-content :deep(li) {
  margin-bottom: 0.5em;
}

.html-content :deep(p) {
  margin-bottom: 1em;
}

.html-content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  margin: 1em 0;
}

/* Error State */
.error-state {
  text-align: center;
  padding: 100px 20px;
}

.error-state i {
  font-size: 80px;
  color: #cbd5e1;
  margin-bottom: 20px;
}

.error-state h3 {
  font-size: 24px;
  color: #334155;
  margin-bottom: 10px;
}

.error-state p {
  color: #64748b;
  margin-bottom: 30px;
}

.back-btn {
  display: inline-block;
  padding: 12px 30px;
  background: #3b82f6;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 700;
}

/* Responsive */
@media (max-width: 992px) {
  .grid-layout {
    grid-template-columns: 1fr;
  }
  
  .image-card {
    max-width: 500px;
    margin: 0 auto 20px;
  }
}

@media (max-width: 768px) {
  .header-content h1 {
    font-size: 28px;
  }
  
  .meta-info {
    flex-direction: column;
    gap: 15px;
  }
  
  .content-card {
    padding: 25px;
  }
}
</style>
